export enum SubscriptionTier {
  Trial,
  Standard
}

export const SubscriptionTierDesc = [
  'Trial',
  'Standard'
];
